import { getBEUrl } from "app/services/api/management";
import { USE_IMAGE_PLACEHOLDERS } from "./constants/paths";
import { VAT_RATES_CZ, VAT_RATES_SK } from "./constants/settings";

export const getAssetPath = (url, size) => {
  if (USE_IMAGE_PLACEHOLDERS) {
    // return `https://via.placeholder.com/${size}.png`;
    return `https://ik.imagekit.io/ikelp/tr:n-xl/b3dd7t/Chicken-Tikka-Masala.png`;
  }

  return url;
};

/**
 *
 * @returns
 */
export const getVatRates = (vatCountryCode = "sk") => {
  const code = (vatCountryCode || "sk").toString().toLowerCase();
  switch (code) {
    case "sk":
      return VAT_RATES_SK;
    case "cz":
      return VAT_RATES_CZ;
    default:
      return VAT_RATES_SK;
  }
};

export const stringToBoolean = (value) => {
  return String(value).toLowerCase() === "true";
};

/**
 * @returns the environment of the project based on the customer's backend domain
 */
export const getProjectEnvBasedOnCustomerBackendDomain = () => {
  const baseURL = window.location.origin;
  const isLocalhost = baseURL.includes("localhost");
  const isStaging = baseURL.includes("staging.gastrokiosk.online");
  const isProd = baseURL.includes("be.gastrokiosk.online");
  if (isLocalhost) {
    return "dev";
  } else if (isStaging) {
    return "stage";
  } else if (isProd) {
    return "prod";
  }
  return "prod";
};
